module.exports = __webpack_public_path__ + "static/media/ngaus.8fd86ff2.png";